import ToastificationContent from '@hw-ui/components/toastification/ToastificationContent.vue'

const onFetchingList = async (store, toast, action, queryParams) => {
  try {
    return await store.dispatch(action, queryParams)
  } catch (error) {
    toast({
      component: ToastificationContent,
      props: {
        title: 'Virhe käyttäjien hakemisessa',
        icon: 'AlertTriangleIcon',
        variant: 'danger',
      },
    })
    return []
  }
}

export {
  // eslint-disable-next-line import/prefer-default-export
  onFetchingList,
}
